import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import { InjectedFormikProps, withFormik } from 'formik'

import Button        from '@material-ui/core/Button'
import Dialog        from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle   from '@material-ui/core/DialogTitle'

import { Study }                                                      from '../../api'
import { EnhancedTextField }                                          from '../atoms'
import { genValueMapper, mapFormikToMuiProps, proxyFormikSubmission } from './form-utils'
import studySchema, { emptyStudy }                                    from './schemas/study.schema'

interface AddStudyDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (values: Study) => void
  close: () => void
}

type Props = InjectedFormikProps<AddStudyDialogProps, Study>

const StudyAddDialog = (props: Props) => {
  const {
    isOpen,
    submitForm,
    close,
  } = props

  const mapper = mapFormikToMuiProps(props)

  return (
    <Dialog
      fullWidth
      open={isOpen}
    >
      <DialogTitle>
        <FormattedMessage id={'generic.addStudy'} />
      </DialogTitle>
      <DialogContent>
        <EnhancedTextField
          fullWidth
          margin={'dense'}
          {...mapper('name')}
        />
        <EnhancedTextField
          fullWidth
          margin={'dense'}
          {...mapper('school')}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={'primary'}
          onClick={close}
        >
          <FormattedMessage id={'buttonActions.cancel'} />
        </Button>
        <Button
          color={'primary'}
          onClick={submitForm}
        >
          <FormattedMessage id={'buttonActions.save'} />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default withFormik<AddStudyDialogProps, Study>({
  validationSchema: studySchema,
  mapPropsToValues: genValueMapper(emptyStudy),
  handleSubmit:     proxyFormikSubmission,
})(StudyAddDialog)



// WEBPACK FOOTER //
// ./src/components/forms/StudyAddDialog.tsx